import React from 'react';
import { InscripcionUIProvider } from './PreInscripcionUIContext';
import { PreInscripcionCard } from './PreInscripcionCard';


const InscripcionPage = () => {
    return (
        <InscripcionUIProvider>
            <PreInscripcionCard />
        </InscripcionUIProvider>
    )
};


export default InscripcionPage;